import { ELEMENTSTYPESIDS } from "../../../../projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds";
import { Geometries, Origins, ReasonsType } from "./critical-area-window.component";
import { ICriticalAreaAction } from "./critical-area.service";

export interface CriticalAreaModel {
  Id: string,
  CriticalAreaId?: string,
  CriticalAreaElementIds: string[],
  ElementInfo?: ElementInfoCriticalArea,
  Label: string,
  AssetId: string,
  RegionId: string,
  RegionIds: string[],
  SectionId: string,
  TargetGeometryIds: string[],
  TargetGeometryTypeId: ELEMENTSTYPESIDS,
  Origin: Origins,
  Geometry: Geometries,
  Reasons: IReasons[],
  DateStarted: Date,
  DateEnded: Date,
  Element: any
  ImprovedTypeDate?: any

  // New properties
  CriticalAreaActions?: ICriticalAreaAction[];
  RepairIds?: string[];
  InspectionIds?: string[];
}

export interface ElementInfoCriticalArea {
  faces: Array<number>;
  type: string;
  vertices: Array<number>;
  holes?: Array<Array<number>>;
}

export interface IReasons {
  reasonName: string,
  reasonTypeId: string,
  active: boolean,
  consequence: number,
  consequenceId: string,
  probabilityOfFailure: number
  probabilityOfFailureCategory?: ProbabilityOfFailure,
  probabilityOfFailureId: string
}

export enum ProbabilityOfFailure {
  NONE,
  RARE,
  UNLIKELY,
  POSSIBLE,
  LIKELY,
  VERY_LIKELY,
}
